module.exports = __webpack_public_path__ + "static/media/whitetick.706b4014.svg";